import { Permission } from '@bookora/shared';

import type { TourDef } from './types';

/**
 * Inline, inside the «ثبت جلسه» drawer: a body-portaled panel is unreachable
 * from inside the Drawer's focus lock. Offered from the SECOND open on this
 * device only — the first open is usually with a patient in the chair.
 *
 * Version 2: the `price` step joined (critic C5/C9). It is written for the
 * package Radio card above «قیمت» (the owner's default for C5): drawing the
 * session off a package is a card that appears when the patient holds a
 * usable package for the chosen service — not an option in «شیوهٔ تسویه» —
 * and the card needs `package.view`, so only those viewers hear about it.
 * The step names no card label, so a wording change there cannot strand it.
 */
export const SESSION_FORM_TOUR: TourDef = {
  key: 'session-form',
  version: 2,
  surface: 'inline',
  inlineHost: 'session-form',
  title: 'فرم ثبت جلسه درمان',
  hubDescription: 'انتخاب خدمت، وضعیت جلسه، قیمت و تسویه، مواد مصرفی و ثبت نهایی.',
  offer: { body: 'چند نکته برای ثبت راحت‌تر جلسه درمان.' },
  route: { path: '/sessions', match: () => false, context: 'session-form' },
  requires: { all: [Permission.SESSION_CREATE] },
  autoOffer: true,
  maxSteps: 5,
  minSteps: 2,
  priority: ['procedure', 'status', 'price', 'consumption', 'submit'],
  steps: [
    {
      id: 'procedure',
      anchor: 'session.procedure',
      title: 'اول، خدمت',
      body: 'با انتخاب خدمت، قیمت پیش‌فرض وارد می‌شه. اگر خدمت رضایت‌نامه لازم داشته باشه، همین‌جا مشخص می‌شه.',
    },
    {
      id: 'status',
      anchor: 'session.status',
      title: 'انجام شد یا برنامه‌ریزی‌شده؟',
      body: 'اگر جلسه درمان همین حالا انجام شده «انجام شد» رو بزنید تا مواد مصرفی از انبار کسر بشه. جلسه درمان بعدی رو «برنامه‌ریزی‌شده» ثبت کنید و وقتی انجام شد، در صفحهٔ همون جلسه درمان «نهایی کردن» رو بزنید.',
    },
    {
      id: 'price',
      anchor: 'session.price',
      title: 'قیمت و تسویه',
      body: (ctx) => {
        const base = 'قیمت از تعرفهٔ خدمت پر می‌شه؛ تخفیف و شیوهٔ تسویه هم همین‌جا ثبت می‌شه.';
        return ctx.can(Permission.PACKAGE_VIEW)
          ? `${base} اگر بیمار برای این خدمت بسته خدمات داره، گزینهٔ کم شدن جلسه درمان از بسته خدماتش بالای قیمت می‌آد.`
          : base;
      },
    },
    {
      id: 'consumption',
      anchor: 'session.consumption',
      requires: { all: [Permission.INVENTORY_CONSUME] },
      title: 'مواد مصرفی',
      body: 'کالایی رو که مصرف کردید اضافه کنید. سری ساختی که زودتر منقضی می‌شه پیشنهاد می‌شه، ولی می‌تونید سری دیگری انتخاب کنید.',
    },
    {
      id: 'submit',
      anchor: 'session.submit',
      title: 'ثبت جلسه',
      body: 'دکمهٔ «ثبت جلسه درمان» بالای فرم است. اگر اطلاعات فرم کامل نباشه، پایین فرم می‌بینید کدوم موارد رو باید کامل کنید.',
    },
  ],
};
